import script from "./CompareOxygen.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareOxygen.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__